import Navbar from "./components/navbar/Navbar"
 
import Wavemill from "./pages/Wavemill"
import Home from "./pages/Home"
import Economics from "./pages/Economics"
import Projects from "./pages/Projects"
import About from "./pages/About"
import Contact from "./pages/Contact"
import { Route, Routes } from "react-router-dom"


function App() {
  return (
  <>
    <Navbar/>
    <div> 
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/wavemill" element={<Wavemill />} />
        <Route path="/economics" element={<Economics />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />            
      </Routes>
    </div>    
    
  </>
  )
}

export default App
